import { render, staticRenderFns } from "./TaxFilingDetail.vue?vue&type=template&id=3c0f049e&scoped=true&"
import script from "./TaxFilingDetail.vue?vue&type=script&lang=js&"
export * from "./TaxFilingDetail.vue?vue&type=script&lang=js&"
import style0 from "./TaxFilingDetail.vue?vue&type=style&index=0&id=3c0f049e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0f049e",
  null
  
)

export default component.exports